import { IThemeContext } from './../../../sites/club/src/contexts/ThemeProvider';
import { IAgreement } from '../dashboard/types';


export function parseAgreementToThemeClub(agreement: IAgreement): IThemeContext {
  return {
    id: agreement.id,
    name: agreement.name,
    slug: agreement.slug,
    logo: agreement.logo,
    banners: agreement.banners,
    customerCentralModule: agreement.customerCentralModule,
    localModule: agreement.localModule,
    cpfModule: agreement.cpfModule,
    metadata: agreement.metadata,
    cellphone: agreement.cellphone,
    exClientModule: agreement.exClientModule,
    colors: {
      primaryColor: agreement.primaryColor,
      secondaryColor: agreement.secondaryColor,
      menuColor: agreement.menuColor,
      menuFontColor: agreement.menuFontColor,
      primaryFontColor: '#747474',
      secondaryFontColor: agreement.secondaryFontColor,
    },
    email: agreement.email,
    idp: agreement.idp,
    childrenList: agreement.children,
    allowCpfLoginMethod: agreement.allowCpfLoginMethod,
    allowPromocodeLoginMethod: agreement.allowPromocodeLoginMethod,
    integratedLogin: agreement.integratedLogin,
    integrationId: agreement.integrationId,
    hasIntegratedPurchaseOnMobileStore: agreement.hasIntegratedPurchaseOnMobileStore,
  };
}
